import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";
import StatusIcon from "../../atoms/StatusIcon";

const StatusDiv: React.FC<{ isExposed?: boolean; color?: string }> = ({
  isExposed,
  color,
  children,
}) => {
  return (
    <StyledIsExposedDiv>
      <StatusIcon isExposed={color !== undefined ? undefined : isExposed} />
      <StyledIsExposedSpan color={color} isExposed={isExposed}>
        {children}
      </StyledIsExposedSpan>
    </StyledIsExposedDiv>
  );
};
export default StatusDiv;

const StyledIsExposedDiv = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  min-height: 24px;
  width: fit-content;
`;
const StyledIsExposedSpan = styled.span<{ isExposed?: boolean }>`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  margin-left: 12px;
  height: 22px;

  color: ${({ isExposed, color }) =>
    color || (isExposed ? theme.colors.mainPrimary3 : theme.colors.gray3)};
`;
